import { title } from './material-kit-react';

const privacyPolicy = {
    section: {
        padding: '70px 0',
        textAlign: 'left',
    },
    title: {
        ...title,
        marginBottom: '1rem',
        marginTop: '30px',
        minHeight: '32px',
        textDecoration: 'none',
    },
    description: {
        color: '#999',
    },
};

export default privacyPolicy;
